import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const TableCell = ({
  className,
  children,
  ...props
}) => (
  <div
    className={cx('table-cell', className)}
    {...props}
  >
    {children}
  </div>
)
TableCell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
}
TableCell.defaultProps = {
  className: '',
  children: null,
}

export default TableCell



// WEBPACK FOOTER //
// ./src/components/Table/tableElements/TableCell.js